import React from 'react';
import { cn } from '../../utils/cn';

export function Input({ className, disabled, ...props }) {
  const inputProps = props.type === 'number'
    ? { ...props, type: 'text', inputMode: props.inputMode || 'decimal' }
    : props;

  return (
    <input
      className={cn(
        'flex h-10 w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm',
        'placeholder:text-slate-400',
        'focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      disabled={disabled}
      {...inputProps}
    />
  );
}

